import { render } from "./ManageRequestEdit.vue?vue&type=template&id=1bcc313c&scoped=true"
import script from "./ManageRequestEdit.vue?vue&type=script&lang=js"
export * from "./ManageRequestEdit.vue?vue&type=script&lang=js"

import "./ManageRequestEdit.vue?vue&type=style&index=0&id=1bcc313c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bcc313c"]])

export default __exports__